import { Component, inject, isDevMode } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { CookieService } from 'ngx-cookie-service';
import { AlertController, Platform } from '@ionic/angular';
import { filter } from 'rxjs/operators';
import { CanonicalService } from './@services/canonical.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent {
  private platform = inject(Platform);
  private router = inject(Router);
  private cookieService = inject(CookieService);
  private alertController = inject(AlertController);
  private canonicalService = inject(CanonicalService);
  constructor() {
    this.initializeApp();
		if (!isDevMode()) {
			console.log = function () { };
		}
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.cookieService.set('company_slug', 'ljhrealty');
      this.cookieService.set('company', '');
      this.cookieService.set('province', '');

      localStorage.clear();
      this.canonicalService.update(this.router.url);

      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event) => {
          if (['/id', '/en', '/id/home', '/en/home'].includes(event.urlAfterRedirects)) {
            this.clearCompanyContext();
          }

          this.canonicalService.update(event.urlAfterRedirects);
        });
    });
  }

  private clearCompanyContext() {
    this.cookieService.set('company_slug', '');
    this.cookieService.set('company', '');
    this.cookieService.set('province', '');
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: 'Under construction!',
      message: 'Sorry, this feature is under construction. Thanks for your understanding.',
      buttons: ['OK'],
    });

    await alert.present();
  }
}
